import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import * as configActions from 'modules/config';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';

import { ConfigTemplate, MyPageTemplate, MyPageTitle } from 'components';
import { CtSmtpTest, CtConfigInitial } from 'containers';

class CtSmtpConf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: 0
      //initValue: {}
    };
  }

  componentDidMount() {
    this.getServiceConfig();
  }

  getServiceConfig = async () => {
    const { ConfigActions, paramInfo } = this.props;

    try {
      await ConfigActions.getServiceConfig({ category: 'smtp' });

      // const initValue = {};
      // for (const key in paramInfo) {
      //   if (paramInfo.hasOwnProperty(key)) {
      //     initValue[key] = paramInfo[key].value || paramInfo[key].defaultValue;
      //   }
      // }

      // this.setState('initValue', initValue);
    } catch (e) {
      console.log(e);
    }

    this.setState({ loaded: 1 });
  };

  render() {
    if (this.state.loaded === 0) {
      return null;
    }

    const { configClassOrder, configParamOrder, mailSmtpTested } = this.props;

    let classOrder = [];
    if (configClassOrder && List.isList(configClassOrder)) {
      classOrder = configClassOrder.toJS();
    }

    let paramOrder = {};
    if (configParamOrder && Map.isMap(configParamOrder)) {
      paramOrder = configParamOrder.toJS();
    }

    let smtpTestInfo = {};
    if (mailSmtpTested && Map.isMap(mailSmtpTested)) {
      smtpTestInfo = mailSmtpTested.toJS();
    }

    return (
      <MyPageTemplate>
        <MyPageTitle small title={'SMTP'}>
          <CtConfigInitial />
        </MyPageTitle>
        <ConfigTemplate category="smtpConfig" order={classOrder} lists={paramOrder} />
        <CtSmtpTest mailSmtpTested={smtpTestInfo} />
      </MyPageTemplate>
    );
  }
}

const mapStateToProps = state => {
  return {
    mailSmtpTested: state.config.getIn(['smtpConfig', 'parameter', 'mailSmtpTested']),
    configClassOrder: state.config.getIn(['smtpConfig', 'classOrder']),
    configParamOrder: state.config.getIn(['smtpConfig', 'class'])
  };
};

const mapDispatchToProps = dispatch => ({
  ConfigActions: bindActionCreators(configActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtSmtpConf);



// WEBPACK FOOTER //
// ./src/script/containers/config/CtSmtpConf.js